export default [
	// RESTRITO
	// restritos, apenas quem é da empresa pode acessar
	{
		modulo: 8,
		privilegio: 336,
		routerName: 'dashboard-dados-sistema',
		routerPath: '/dashboard-dados-sistema',
		componentName: 'dashboardDadosSistema',
		componentPath: 'modules/restrito/dashboard-dados-sistema/main'
	},
	{
		modulo: 8,
		privilegio: 66,
		routerName: 'posicaoDeVoo',
		routerPath: '/gerenciamento-de-voo',
		componentName: 'GerencimentoVoo',
		componentPath: 'modules/restrito/gerenciamento-voo/main'
	},
	{
		modulo: 8,
		privilegio: 262,
		routerName: 'gerenciamentoDeTrecho',
		routerPath: '/gerenciamento-de-trechos',
		componentName: 'gerenciamentoTrecho',
		componentPath: 'modules/restrito/gerenciamento-trechos/main'
	},
	{
		modulo: 8,
		privilegio: 66,
		routerName: 'cliente-sistema',
		routerPath: '/cliente-sistema',
		componentName: 'SistemaCliente',
		componentPath: 'modules/restrito/cliente/main'
	},
	{
		modulo: 8,
		privilegio: 86,
		routerName: 'notificacao-sistema',
		routerPath: '/cliente-notificacao',
		componentName: 'SistemaNotificacao',
		componentPath: 'modules/restrito/notificacao/main'
	},
	{
		modulo: 8,
		privilegio: 66,
		routerName: 'log-processamento',
		routerPath: '/log-processamento',
		componentName: 'LogProcessamento',
		componentPath: 'modules/restrito/log-processamento/main'
	},
	{
		modulo: 8,
		privilegio: 66,
		routerName: 'config-backend',
		routerPath: '/config-backend',
		componentName: 'ConfigBackend',
		componentPath: 'modules/restrito/config-backend/main'
	}
]
